/**
 * Het licht van een brandende uitgang.
 *
 * ── DE TEGEL IS DE LAMP ─────────────────────────────────────────────────────
 *
 * Wat de domoticapagina vervangt is een wandplaat met schakelaars. Wat die goed maakte:
 * ze zaten altijd op dezelfde plek, en je zag van de andere kant van de kamer of er
 * licht brandde. Dat is de eigenschap om na te bouwen — niet de bediening van een app.
 *
 * Dus draagt de KAART het licht: een zachte gloed achter het pictogram, een warme tint
 * over het vlak, een warme rand. Geen tekst, geen badge, geen schakelaartje. En bij een
 * dimmer volgt de sterkte van die gloed de stand van de lamp: 20% gloeit minder dan vol.
 *
 * ── WAAROM DIT EEN EIGEN BESTAND IS ─────────────────────────────────────────
 *
 * Dezelfde lamp staat op twee schermen: de domoticapagina en het beginscherm. Stonden de
 * kleuren op allebei apart, dan lopen ze uit elkaar zodra iemand er één bijstelt — en
 * dan ziet dezelfde lamp er twee schermen verderop anders uit. Dat was precies een van
 * de bevindingen uit de eerste testronde.
 */

export const LICHT_KERN = '#FFD98A';                    // de gloed zelf
export const LICHT_RAND = 'rgba(240, 158, 40, 0.30)';   // waar hij uitdooft
export const WARM = '#D9820F';                          // rand en tekst; donker genoeg op wit
export const WARM_TINT = 'rgba(255, 205, 120, 0.18)';

/** De pruimkleur van de huisstijl, voor sferen — zodat een sfeer geen lamp lijkt. */
export const SFEER = 'var(--caro-primary)';

/**
 * De achtergrond van een brandende tegel.
 *
 * @param sterkte 0..1 — de stand van de dimmer. Een half opengedraaide lamp geeft ook
 *                half zo veel licht op het scherm.
 */
export function lichtVlak(sterkte: number): string {
  const kern = Math.max(0.18, Math.min(1, sterkte));
  return `radial-gradient(circle at 50% 38%, `
    + `color-mix(in srgb, ${LICHT_KERN} ${Math.round(kern * 62)}%, transparent) 0%, `
    + `${LICHT_RAND} 42%, transparent 72%), `
    + `linear-gradient(${WARM_TINT}, ${WARM_TINT})`;
}

/**
 * De schaduw eronder.
 *
 * Warm en gericht: licht valt naar beneden, dus de gloed onder de kaart hoort erbij. Een
 * grijze doosschaduw zou de illusie meteen breken.
 */
export const LICHT_SCHADUW = `0 10px 26px -12px rgba(217,130,15,0.55), 0 0 0 1px ${WARM} inset`;
export const RUST_SCHADUW = '0 1px 3px rgba(0,0,0,0.06)';
export const SFEER_SCHADUW = '0 6px 18px -12px rgba(154,63,105,0.45)';
